module.exports = __webpack_public_path__ + "img/wire-transfer.8d2f5ffa.svg";